// ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    // Current path और search parameters दोनों save करें
    const redirectPath = location.pathname + (location.search || '');
    console.log("Redirect path saved:", redirectPath);
    localStorage.setItem("postLoginRedirect", redirectPath);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;